import cn from 'classnames';
import { Button } from 'components/Button';
import Modal from 'components/Shared/Modal';
import Overlay from 'components/Shared/Overlay/';
import { isMobile } from 'components/Shared/responsive';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { rm } from 'utils';
import { CheckoutDatePicker } from './CheckoutDatePicker';
import styles from './calendar.scss';

interface OwnProps {
  onDateChange: (date: Date) => void;
  toggleDateSelector: (value?: unknown) => void;
  showDateSelector: boolean;
  rangeStartDate: Date;
  rangeEndDate: Date;
  title: string | JSX.Element;
  browseCalendar?: boolean;
  selectedDate?: Date;
  shouldBeDisabled: boolean;
}

export const Calendar = ({
  onDateChange,
  rangeStartDate,
  rangeEndDate,
  title,
  selectedDate,
  showDateSelector,
  toggleDateSelector,
  shouldBeDisabled
}: OwnProps): JSX.Element => {
  const mobile = useSelector(isMobile);
  const [show, setShow] = useState(false);
  const openModal = () => setShow(true);
  const closeModal = () => setShow(false);

  const onClick = () => {
    toggleDateSelector(false);
  };

  const onSelectedDateInModal = (date: Date) => {
    onDateChange(date);
    setShow(false);
  };

  return (
    <>
      <Overlay transparent isFilterOverlay visible={showDateSelector} onClick={onClick} />
      <div className={styles.buttonWrapper}>
        <label>{title}</label>
        <Button
          appearance="whitePill"
          onClick={mobile ? openModal : toggleDateSelector}
          className={styles.toggleButton}
          disabled={shouldBeDisabled}
        >
          {selectedDate
            ? selectedDate.toLocaleString(`sv-SE`).slice(0, 10)
            : rm('checkout_calendar_pick_date')}
        </Button>
      </div>

      <div
        className={cn(styles.calendarWrapper, mobile ? styles.mobile : '', {
          [styles.hide]: !showDateSelector
        })}
      >
        {mobile ? (
          <Modal show={show} onClose={closeModal} contentClassName={styles.checkoutModal}>
            <CheckoutDatePicker
              rangeStartDate={rangeStartDate}
              rangeEndDate={rangeEndDate}
              selectDate={(date: Date) => onSelectedDateInModal(date)}
              selectedDate={selectedDate}
              browseCalendar
            />
          </Modal>
        ) : (
          <CheckoutDatePicker
            rangeStartDate={rangeStartDate}
            rangeEndDate={rangeEndDate}
            selectDate={(date: Date) => onDateChange(date)}
            selectedDate={selectedDate}
            browseCalendar
          />
        )}
      </div>
    </>
  );
};
